import { toast } from "sonner";
import { api } from "@/lib/api";

const loadRazorpay = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => reject(new Error("Could not load Razorpay"));
    document.body.appendChild(s);
  });

// data = response from /orders/checkout, /wallet/topup or /payments/checkout
export const launchPayment = async (data, { description = "PRE-IPO EXPERT", onCancel } = {}) => {
  if (data.provider !== "razorpay") {
    window.location.href = data.checkout_url;
    return;
  }
  const Razorpay = await loadRazorpay();
  const rzp = new Razorpay({
    key: data.key_id,
    amount: data.amount_paise,
    currency: data.currency,
    order_id: data.order_id,
    name: "PRE-IPO EXPERT",
    description,
    image: `${window.location.origin}/logo.png`,
    prefill: data.prefill,
    theme: { color: "#6D28D9" },
    handler: async (res) => {
      try {
        await api.post("/payments/razorpay/verify", res);
        window.location.href = `/payment/success?session_id=${data.order_id}`;
      } catch {
        toast.error("Payment received but could not be verified yet. Our desk will confirm shortly.");
        window.location.href = `/payment/success?session_id=${data.order_id}`;
      }
    },
    modal: { ondismiss: () => { toast("Payment cancelled."); onCancel?.(); } },
  });
  rzp.on("payment.failed", (r) => toast.error(r?.error?.description || "Payment failed. Please try again."));
  rzp.open();
};
